export class FilteredWhiteListFilterList {
    filterWhiteListNameId : string = ""

    filterWhiteListName : string = ""

}